module.exports = __webpack_public_path__ + "static/logo-829a574ea218acd325d4b6b77bae2666.png";